import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../features/modal/ModalSlice";
import CustomInputBox from "../../Form/CustomInputBox";
import { Numbers, Phone } from "@mui/icons-material";
import { Box, FormControl, Stack, Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import CustomButton from "../../Button/CustomButton";
import apiClient from "../../../services/apiClient";
import { useNavigate } from "react-router-dom";
import { LuFileInput, LuTextCursorInput } from "react-icons/lu";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { FiHash } from "react-icons/fi";
import { RiVoiceprintFill } from "react-icons/ri";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { FaUserTie } from "react-icons/fa6";
import { AiOutlineCode } from "react-icons/ai";
import FileUrlInput from "../../Form/FileUrlInput";

const AddAiAgent = () => {
  const [formData, setFormData] = useState({
    agent_name: "",
    model_name: "llama",
    model_id: "",
    raw_text: "",
    website_url: "",
  });

  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo.user);

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};
    if (formData.no_of_phones_required > 2) {
      tempErrors.no_of_phones_required = "You can request maximum up to 2 numbers";
    }
    if (formData.extension_start_range <= 10000) {
      tempErrors.extension_start_range = "Extension start range must be greater than 10000";
    }
    if (formData.extension_start_range >= formData.extension_end_range) {
      tempErrors.extension_range = "Extension start range must be smaller than extension end range";
    }
    if (formData.extension_end_range - formData.extension_start_range > 5) {
      tempErrors.extension_range = "You can request a maximum of 5 extensions";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const payload = new FormData();

    // Append files
    files.forEach((file, index) => {
      payload.append(`files[]`, file); // You can use file.name if needed
    });

    // Append Form fields
    Object.entries(formData).forEach(([key, value]) => {
      payload.append(key, value);
    });

    payload.append("user_id", userInfo?.id);

    try {
      await apiClient.post("/create-agent", payload);

      // fetchRequests();
      handleClosePopup();
      navigate("/ai-agent");
    } catch (error) {
      console.error("Error Creating AI Agent:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={"rightModal taskModal"} style={{ width: "450px" }}>
      <div className="modal-header p-3">
        <h4 className="m-0">Create Agent</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <div className="">
          <div className="inputData withIcon mb-4">
            <span className="icon">
              <LuTextCursorInput />
            </span>
            <input
              className="form-control"
              type="text"
              name="agent_name"
              required
              onChange={handleChange}
            />
            <label className="label">Agent Name</label>
          </div>

          <div className="inputData withIcon mb-4">
            <FileUrlInput
              text={formData?.raw_text}
              setText={(text) => setFormData((prev) => ({ ...prev, raw_text: text }))}
              files={files}
              setFiles={setFiles}
            />
          </div>

          <div className="inputData withIcon mb-4">
            <span className="icon">
              <LuTextCursorInput />
            </span>
            <input
              className="form-control"
              type="text"
              name="website_url"
              required
              onChange={handleChange}
            />
            <label className="label">Website URL</label>
          </div>

          <div className="inputData selectForm mb-4">
            {/* <label>Choose AI Voice</label> */}
            <span className="icon">
              <RiVoiceprintFill />
            </span>
            <select className="form-select" onChange={handleChange} name="model_id">
              <option>Choose AI Voice</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>

          <div class="inputData textareaData withIcon mb-4">
            <span className="icon">
              <FaUserTie />
            </span>
            <textarea className="form-control h-auto" rows="5" cols="80" required></textarea>
            <label className="label">Personality Define</label>
            <div class="needHelp text-end">
              Need Help{" "}
              <Tooltip
                disableFocusListener
                title="This is for creating the ai agent for dialgrid. It can only be created in dialgrid from admin."
              >
                <span className="ms-1">
                  <BsFillQuestionCircleFill />
                </span>
              </Tooltip>
            </div>
          </div>

          <div class="inputData textareaData withIcon mb-4">
            <span className="icon">
              <AiOutlineCode />
            </span>
            <textarea className="form-control h-auto" rows="5" cols="80" required></textarea>
            <label className="label">Sales Script</label>
            <div class="needHelp text-end">
              Need Help{" "}
              <Tooltip
                disableFocusListener
                title="This is for creating the ai agent for dialgrid. It can only be created in dialgrid from admin."
              >
                <span className="ms-1">
                  <BsFillQuestionCircleFill />
                </span>
              </Tooltip>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-3 my-4">
            <CustomButton
              type="submit"
              variant="contained"
              color="secondary"
              onClick={handleClosePopup}
            >
              Cancel
            </CustomButton>
            <CustomButton
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              loading={loading}
            >
              Submit
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAiAgent;
